<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <div class="section-title">{{ $t("institution") }}</div>
      <router-link
        v-if="$can('create', 'Institution')"
        class="btn-blue"
        to="add-institution"
        >{{ $t("add") }}</router-link
      >
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="getInstituteList"
          v-model="searchValue"
          :placeholder="$tc('searchs')"
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              getInstituteList(filterIsActive);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;{{ $t("of") }}&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>
    <div>
      <table class="list-view-table">
        <thead>
          <tr>
            <th class="text-left">
              <span class="pr-3">{{ $tc("status", 2) }}</span>
            </th>
            <th>
              <img
                v-if="this.columnName != 'institution_name'"
                @click="onSortValue('institution_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('institution_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('institution_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $t("institution") }} {{ $t("name") }}
            </th>
            <th>
              <img
                v-if="this.columnName != 'cine_name'"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/updown.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else-if="isSort && isAscending"
                @click="onSortValue('cine_name', 'asc')"
                src="@/assets/img/icons/asc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              <img
                v-else
                @click="onSortValue('cine_name', 'desc')"
                src="@/assets/img/icons/desc.svg"
                class="cursor-pointer"
                width="15px"
                height="20px"
              />
              {{ $tc("cinema", 1) }}
            </th>
          </tr>
        </thead>
        <tbody v-if="institutename && institutename.length > 0">
          <tr
            v-for="(institute, instituteIndex) in institutename"
            :key="instituteIndex"
          >
            <!-- <td>
              <div class="d-flex align-items-center justify-content-end">
                <StatusDot
                  :status="
                    institute.institution_is_active === 'Y'
                      ? 'active'
                      : institute.institution_is_active === 'N' && 'inactive'
                  "
                />
                <b-dropdown right variant="edit" class="ml-4">
                  <b-dropdown-item
                    v-if="$can('update', 'Institution')"
                    v-on:click="onEditInstitute(institute)"
                  >
                    <span class="edit-pen"></span>
                    {{ $t("edit") }}
                  </b-dropdown-item>
                  <b-dropdown-item v-on:click="onViewInstitute(institute)">
                    <span class="icon-eye"></span>
                    {{ $t("view") }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </td> -->
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="
                    institute.institution_is_active === 'Y'
                      ? 'active'
                      : 'inactive'
                  "
                />

                <i
                  v-if="$can('update', 'Institution')"
                  class="edit-pen icon blue-icon cursor-pointer ml-4"
                  v-on:click="onEditInstitute(institute)"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                ></i>

                <i
                  class="icon-eye blue-icon cursor-pointer ml-2"
                  v-on:click="onViewInstitute(institute)"
                  v-b-tooltip="'View'"
                  tabindex="0"
                ></i>
              </div>
            </td>

            <td>{{ institute.institution_name }}</td>
            <td>{{ institute.cine_name }}</td>
          </tr>
        </tbody>

        <tbody v-else>
          <tr>
            <td colspan="3">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination
        v-if="institutename.length > 0"
        v-model="currentPage"
        :total-rows="rows"
        @change="onChangePagination($event)"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      institution_id: "",
      institute_id: "",
      institute_name: "",
      institutename: [],
      // institutes: [],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
    };
  },
  beforeMount() {
    this.getInstituteList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getInstituteList();
    },
    getInstituteList(filterIsActive = "Y") {
      this.institute_name = [];
      MarketingService.getAllInstitutes(
        this.perPage,
        this.currentPage,
        this.columnName,
        this.orderby,
        this.searchValue,
        filterIsActive
      ).then((response) => {
        const { data } = response;

        if (data && data.status && data.Records && data.Records.length > 0) {
          this.institutename = data.Records;
          this.rows = data.totalCount;
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    onViewInstitute: function (institute) {
      this.$router.push({
        path: "/marketing/view-institution",
        query: { institution_id: institute.institution_id },
      });
    },
    onEditInstitute: function (institute) {
      this.$router.push({
        path: "/marketing/edit-institution",
        query: { institution_id: institute.institution_id },
      });
    },

    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getInstituteList();
      } else {
        this.currentPage = event;
        this.getInstituteList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/InstitutionComponents/institution.vue